<template>
    <div class="columns is-multiline is-centered img-cols">
       
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
        <div v-for="ban in banners" 
            :key="ban.id" 
            class="column has-text-centered"
            :class="ban.fullWidth ? 'is-full' : 'is-half'">
            <a v-if="ban.link" target="_blank" :href="ban.link">
                <img :src="ban.image" style="width=100%;" alt="banner">
            </a>
            <img v-else :src="ban.image" style="width=100%;" alt="full-width-banner">
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        dataUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            banners:[],
            loading:false
        }
    },
    methods:{
        async fetchBanners(){
            let url = this.dataUrl + "?visible=True"
            console.log("daleeee", url)
            this.loading = true
            this.banners = await getHandler(url, {error:false, succes:false})
            this.loading = false      
        }
    },
    created(){
        this.fetchBanners()
    }
}
</script>

<style lang="scss" scoped>
.img-cols{
    padding-left:4rem;
    padding-right:4rem;
    @media (max-width: 1023px) {
        padding-left:2.5rem;
        padding-right:2.5rem;
    }
}
</style>